var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gpt column"},[_c('TableBaseComponent',{attrs:{"header":['Produto ou serviço'],"rows":_vm.buildRows()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }